import { render, staticRenderFns } from "./AdminStructureForm.vue?vue&type=template&id=d29e260e"
import script from "./AdminStructureForm.vue?vue&type=script&lang=js"
export * from "./AdminStructureForm.vue?vue&type=script&lang=js"
import style0 from "./AdminStructureForm.vue?vue&type=style&index=0&id=d29e260e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports